import { createListenerMiddleware } from '@reduxjs/toolkit';
import { executeCommandsListener } from './CommandState/CommandState.listeners';
import { getCitiesListener, updatedCountryListener, selectedCityListener, updatedZipcodeListener } from './UserAddressState/UserAddressState.listeners';

// import type { RootState, AppDispatch } from './store';

// TODO (jcheung) refine any types

// export type AppListenerEffectApi = ListenerEffectAPI<RootState, AppDispatch>;

export var listenerMiddleware = createListenerMiddleware({
  onError: function onError() {
    return console.error;
  }
});

// TODO (jcheung) investigate why "withTypes" is missing from listenerMiddleware
//   (see https://redux-toolkit.js.org/api/createListenerMiddleware#typescript-usage)
export var startAppListening = listenerMiddleware.startListening;
// export const startAppListening = listenerMiddleware.startListening.withTypes<
//   RootState,
//   AppDispatch
// >()

startAppListening(executeCommandsListener);
startAppListening(getCitiesListener);
startAppListening(updatedCountryListener);
startAppListening(selectedCityListener);
startAppListening(updatedZipcodeListener);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/redux/listeners.js
// module id = 4423
// module chunks = 11